import usePageSEO from '@/hooks/usePageSEO';
import { useLanguage } from '@/contexts/LanguageContext';
import PageLayout from '@/components/feature/PageLayout';
import SolutionsHero from './components/SolutionsHero';
import SolutionsScenes from './components/SolutionsScenes';
import SolutionsProcess from './components/SolutionsProcess';
import SolutionsCTA from './components/SolutionsCTA';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://www.juuliang.com';

export default function Solutions() {
  const { lang } = useLanguage();

  usePageSEO({
    title: {
      zh: '應用場景與解決方案｜聚量應用材料 — 廢棄塑膠再生 · 循環經濟 · ESG 低碳製造',
      en: 'Applications & Solutions | PolyQ Applied Materials — Plastic Waste Recycling · Circular Economy · ESG Low-Carbon Manufacturing',
      ja: '応用シーンとソリューション | 聚量応用材料 — 廃プラスチック再生・サーキュラーエコノミー・ESG低炭素製造',
    },
    description: {
      zh: '聚量提供六大應用場景解決方案，涵蓋塑膠回收廠、造粒廠、射出押出廠、品牌 ESG 專案、農業廢棄塑膠與政府示範場域，協助導入高比例再生料與低碳材料。',
      en: 'PolyQ provides six application scenario solutions covering plastic recyclers, compounders, injection/extrusion manufacturers, brand ESG projects, agricultural plastic waste, and government demonstration sites, helping adopt high recycled content and low-carbon materials.',
      ja: '聚量はプラスチックリサイクル業者・造粒業者・射出押出メーカー・ブランドESGプロジェクト・農業廃プラスチック・政府実証サイトをカバーする6つの応用シーンソリューションを提供し、高再生材料比率と低炭素材料の導入を支援します。',
    },
    keywords: {
      zh: '廢棄塑膠再生, 應用場景, 解決方案, 塑膠回收廠, 射出押出, ESG 專案, 農業廢塑膠, 循環經濟, 低碳製造, 聚量應用材料',
      en: 'plastic waste recycling, application scenarios, solutions, plastic recyclers, injection extrusion, ESG projects, agricultural plastic waste, circular economy, low-carbon manufacturing, PolyQ Applied Materials',
      ja: '廃プラスチック再生, 応用シーン, ソリューション, プラスチックリサイクル業者, 射出押出, ESGプロジェクト, 農業廃プラスチック, サーキュラーエコノミー, 低炭素製造, 聚量応用材料',
    },
    path: '/solutions',
    jsonLd: {
      '@type': 'WebPage',
      name: (lang === 'en' ? 'Applications & Solutions' : lang === 'ja' ? '応用シーンとソリューション' : '應用場景與解決方案'),
      url: siteUrl + '/solutions',
      description: (lang === 'en'
        ? 'PolyQ provides six application scenario solutions for plastic waste recycling, circular economy, and low-carbon manufacturing.'
        : lang === 'ja'
          ? '聚量は廃プラスチック再生・サーキュラーエコノミー・低炭素製造のための6つの応用シーンソリューションを提供します。'
          : '聚量提供六大應用場景解決方案，涵蓋塑膠回收、射出押出、品牌 ESG、農業廢塑膠等領域。'),
    },
  });

  return (
    <PageLayout>
      <SolutionsHero />
      <SolutionsScenes />
      <SolutionsProcess />
      <SolutionsCTA />
    </PageLayout>
  );
}